import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useLoader } from "@/app/hooks/useLoader";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import DataTable from "@/app/components/ui/Reusable/DataTable";
import { getStandardShiftsColumns } from "@/app/hooks/custom_hooks";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import { IRotaState, setShiftDetails } from "@/app_redux/reducers/slices/auth/rota_slice";

const SetupStandardShiftComponent = ({ setActiveStat }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");
  const isShiftLoading = useLoader("isRotaShiftListInProgress");
  const { routeState } = useRouteInfo(routeId);
  const { shiftList } = routeState.state as IRotaState;
  const columns = getStandardShiftsColumns(navigate, getRouteKey, setActiveStat);

  useEffect(() => {
    dispatch(setShiftDetails({ data: null }));
  }, []);

  return !isShiftLoading ? <DataTable data={shiftList || []} columns={columns} maxHeight="600px" /> : <TableSkeleton />;
};

export default SetupStandardShiftComponent;
